// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8ab44547","885":"f295da13"}[chunkId] + ".chunk.js";
};